module.exports = __webpack_public_path__ + "assets/posa-logo.3da3777da5e290a6a3629bd48726603f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/posa-logo.png
// module id = 113
// module chunks = 0